import { Controller } from "@hotwired/stimulus"

// Swaps the CSS class on a container based on a select value.
// Used by due date syncing rule selects in task templates and task fieldsets.
export default class extends Controller {
  toggle(event) {
    const container = event.target.closest("[data-syncing-rule]")
    if (container) {
      container.className = event.target.value
    }
  }
}
